import { Placement } from '@popperjs/core';
import hoistNonReactStatics from 'hoist-non-react-statics';
import React, { FC, useMemo } from 'react';
import { TooltipOffset } from 'ia-react-core/~/interfaces/TooltipOffset';

import Tooltip from '../Tooltip';
import { StatusTooltipProps } from './StatusTooltip';

const withTooltip = (WrappedComponent: FC<StatusTooltipProps>) => hoistNonReactStatics((props) => {
  const { tip, trigger, placement } = props;

  const offset: TooltipOffset = useMemo(() => ({ placement: currentPlacement }: { placement: Placement}) => {
    if (currentPlacement === 'bottom') {
      return [0, 3];
    }
    return [0, 4];
  }, []);

  return (
    <Tooltip
      tip={tip}
      trigger={trigger}
      offset={offset}
      placement={placement}
    >
      {(tooltipProps) => (
        <WrappedComponent
          {...props}
          {...tooltipProps}
        />
      )}
    </Tooltip>
  );
}, WrappedComponent);

export default withTooltip;
